import { render } from "./BuddyAvatar.vue?vue&type=template&id=230ff1aa&scoped=true"
import script from "./BuddyAvatar.vue?vue&type=script&lang=js"
export * from "./BuddyAvatar.vue?vue&type=script&lang=js"

import "./BuddyAvatar.vue?vue&type=style&index=0&id=230ff1aa&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230ff1aa"]])

export default __exports__